import React from 'react';
import { usePostbackCampaignSpentSaveMutation } from 'modules/PostbacksModule/api/postback-campaign-spent.api';
import { Spin } from 'antd';
import Alert from 'components/Dialogs/Alert';
import ninjaApi from 'store/redux/apis';
import CampaignSpent from 'components/CampaignSpent';
import DeleteReceivedPostback from '../DeleteReceivedPostback';

const PostbackCampaignSpent = ({ loading, data, id }) => {
  const [postbackCampaignSpentSave, { isLoading }] = usePostbackCampaignSpentSaveMutation();
  const [getPostbackCampaignSpentQuery, { data: list = [] }] =
    ninjaApi.useLazyPostbackCampaignSpentListQuery();

  return (
    <div className='grid gap-4 mt-4'>
      <Alert
        type='warning'
        description='Any new campaigns added in the future will be automatically included unless manually excluded'
      />
      {loading ? (
        <Spin />
      ) : (
        <CampaignSpent
          isLoading={isLoading}
          campaignSpentSave={postbackCampaignSpentSave}
          getCampaignSpentQuery={getPostbackCampaignSpentQuery}
          store={data}
          data={list}
          params='postback_id'
          extraAction={<DeleteReceivedPostback id={id} />}
        />
      )}
    </div>
  );
};

export default PostbackCampaignSpent;
